import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";

// Action for fetching inventory summary from the new endpoint
export const fetchInventoryUpload = createAsyncThunk("fetchInventoryUpload", async ({ channel_id, file, sub_channel_id }, { rejectWithValue }) => {
	try {
		const formData = new FormData();
		formData.append("file", file);
		const response = await axiosHttp.post(`channel/${channel_id}/stock/upload?subChannelUuid=${sub_channel_id}`, formData);
		message.success("Inventory uploaded successfully!");
		return response.data.data;
	} catch (error) {
		const errorMsg = error.response?.data?.message || "Something went wrong";
		message.error(errorMsg); // Show error in Ant message
		return rejectWithValue(errorMsg);
	}
});

const RewardInventoryUploadSlice = createSlice({
	name: "RewardInventoryUploadSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetRewardInventoryUploadSlice: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchInventoryUpload.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(fetchInventoryUpload.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchInventoryUpload.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Unknown error occurred";
		});
	},
});

export default RewardInventoryUploadSlice.reducer;
export const { resetRewardInventoryUploadSlice } = RewardInventoryUploadSlice.actions;
